import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NiSelectManagerService {
  private readonly closeAllSubject = new Subject<string>();
  
  closeAll$ = this.closeAllSubject.asObservable();

  closeAllExcept(exceptId: string): void {
    this.closeAllSubject.next(exceptId);
  }
}